const OurMissionApi = [
    { details: "Committed to providing innovative solutions in dewatering." },
    { details: "Dedicated to offering high-quality pump products." },
    { details: "Ensuring exceptional customer services with reliability." }
];

export default OurMissionApi;
